import React from "react";
import cvData from "../data/cvData.json";
import { convertTextToLinks } from "../helpers/helper";

const IdealNextJob = () => {
  const { idealNextJob } = cvData;

  return (
    <section id="ideal-next-job" className="relative z-10 mx-auto w-full max-w-6xl px-6 py-12">
      <div className="glass-panel glass-sheen p-6 md:p-10">
        <h2 className="section-title">My Ideal Next Job</h2>
        <div className="mt-6 space-y-4 text-left text-base text-text-secondary md:text-lg">
          {idealNextJob.map((paragraph, index) => (
            <p key={index}>{convertTextToLinks(paragraph)}</p>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IdealNextJob;
